import request from "../utils/request"

export function fetchBanners(params = {}) {
  return request({
    url: "/admin/app-banners",
    method: "get",
    params
  })
}

export function fetchBannerRoutes() {
  return request({
    url: "/admin/app-banners/routes",
    method: "get"
  })
}

export function saveBanner(data) {
  return request({
    url: "/admin/app-banners",
    method: "post",
    data
  })
}

export function uploadBannerImage(file) {
  const formData = new FormData()
  formData.append("file", file)
  return request({
    url: "/admin/app-banners/images/upload",
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data"
    }
  })
}

export function moveBanner(id, direction) {
  return request({
    url: `/admin/app-banners/${id}/move`,
    method: "post",
    params: { direction }
  })
}

export function deleteBanner(id) {
  return request({
    url: `/admin/app-banners/${id}`,
    method: "delete"
  })
}
